import {Injectable} from '@angular/core';
import {environment} from './../../../../environments/environment';
import {channel, rememberMeCookieDetails} from './config.constants';
import {DeviceDetectorService} from 'ngx-device-detector';
import {UtilityCookieService} from './../../utils/cookie/utilitycookie.service';


export const ENVIROMENTS: any = [
  '-qa',
  '-sit',
  '-reg',
  '-uat',
  't.cvs.com',
  'www.cvs.com',
  'message.cvs.com',
  'www-beta.cvs.com',
  'cdcprd1-csr.cvs.com',
  'cdcprd2-csr.cvs.com'
];

@Injectable({
  providedIn: 'root'
})
export class ConfigService {

  public selectedEnvironment: Object = {};
  private channel: string;
  private deviceType: string;
  private form: string;

  private _config: object = {
    version: '1.0',
    apiRoot: '/Services/icet/',
    channelName: (this.deviceDetector.isDesktop() ? 'WEB' : 'MOBILE'),
    deviceToken: '7777',
    apiDeviceToken: 'd9708df38d23192e',
    lineOfBusiness: 'ICE',
    xmlFormat: 'False',
    cookiesDomain: environment.local ? 'localhost' : '.cvs.com', // cookiesDomain: 'localhost',
    cookiesSecure: environment.local ? false : true, // cookiesSecure: false,
    oneSiteCookieName: 'CVS_SSO_TOKEN', // onesite token for Retail Channel
    hcOneSiteCookieName: '12345678912345678912345678912345', // hardcoded SSO token
    authLoginCookieName: 'AUTH_LOGIN',
    sccCookieName: 'SCC_COOKIE',
    iceCookieName: 'ICE',
    authLoginCookies: 'USER_TOKEN', // Cookie name to use loginCookies
    userSSoToken: 'USER_SSOTOKEN', // New Cookie for login
    rememberMeCookieName: 'ICE_REMEMBER_v1',
    cacheCookieName: 'ICEC',
    cvsComRootUrl: 'https://www.cvs.com'
  };
  private _sitConfig = {
    tealiumUrl: '//tags.tiqcdn.com/utag/cvs/icet/qa/utag.js',
    apiKey: 'c69e906f-5c23-4be8-be73-d43527cece5b',
    ice: '2e77f5eb-016f-44a6-8d73-d5f2e6a01a54',
    mdp: 'eecf28c2-de77-44da-82b2-a7b102121ddd',
    apiSecret: '040fcd53-a4be-4638-8720-e15c26290cbb',
    servicesApiKey: '2e77f5eb-016f-44a6-8d73-d5f2e6a01a54',
    servicesApiSecret: 'bf2a3c64-16df-4bfe-8fa9-53c24b079ea7'
  };

  private _prodConfig = {
    tealiumUrl: '//tags.tiqcdn.com/utag/cvs/icet/prod/utag.js',
    apiKey: '8dcc0289-81ef-42c6-8d1f-a6e56abcd2d2',
    ice: 'a2ff75c6-2da7-4299-929d-d670d827ab4a',
    mdp: '89e24b45-0988-494f-bf61-61fc3ded0b27',
    apiSecret: '6a88b8e0-a504-461b-a03d-f0be5b892884',
    servicesApiKey: 'a2ff75c6-2da7-4299-929d-d670d827ab4a',
    servicesApiSecret: 'a8df2d6e-b11c-4b73-8bd3-71afc2515dae'
  };

  constructor(private deviceDetector: DeviceDetectorService, private cookieService: UtilityCookieService) {
    this.getDeviceInfo();
    if (!this.form) {
      this.form = this.deviceDetector.isMobile() ? 'MOBILE' : 'TABLET';
    }
    this.channel = UtilityCookieService.getCookie('Channel');
    this.getEnvironment();
  }

  public getHostName() {
    const host = (<any>window).location.host;
    let subDomain = '';
    if (host.match('caremark.com') || host.match('cvs.com')) {
      // adds support to run on caremark
      let env = host.indexOf('.caremark.com');
      if (env === -1) {
        env = host.indexOf('.cvs.com');
      }
      subDomain = host.substring(0, env);
      const isValid = ENVIROMENTS.some(h => {
        return subDomain.indexOf(h) > -1 && host.length < 30;
      });
      return isValid || ENVIROMENTS.indexOf(subDomain) > -1 || ENVIROMENTS.indexOf(host) > -1 ? host : 'www.cvs.com';
    }
    return 'www.cvs.com';
  }

  public getEnvironment() {
    let _env = Object.assign(this.selectedEnvironment, this._config, this._sitConfig);
    let host = (<any>window).location.host;
    if (host.match('caremark.com') || host.match('cvs.com')) {
      let env = host.indexOf('.caremark.com');
      if (env === -1) {
        env = host.indexOf('.cvs.com');
      }
      host = host.substring(0, env);
      // Production environment host
      /*
      m - mobile web -  m.cvs.com
      es - spanish - es.cvs.com
      t - ICE env - t.cvs.com/ t.caremark.com
      www - Retail - www.cvs.com
      www-beta - production beta - www-beta.cvs.com
      */
      if (host === 'm' || host === 'es' || host === 't' || host === 'www' || host === 't-akatest' || host === 'www-beta') {
        _env = Object.assign(this.selectedEnvironment, this._prodConfig);
      }
    }
    this.selectedEnvironment = _env;
    return this.selectedEnvironment;
  }

  public get(key: string) {
    return this.selectedEnvironment[key];
  }

  getTealiumEnv(): string {
    return environment.production ? 'PRODUCTION' : 'STAGING';
  }

  getDeviceType(): string {
    return this.deviceType;
  }

  getForm(): string {
    return this.form;
  }

  getSource(mdp?): string {
    if (channel.RETAIL_ANDRIOD_APP === this.channel || channel.RETAIL_IOS_APP === this.channel) {
      return mdp ? 'MDP_APP' : 'ICE_APP';
    } else {
      return mdp ? 'MDP_WEB' : 'ICE_WEB';
    }
  }

  getAppName(): string {
    if (this.deviceType === 'DESKTOP') {
      return 'ICE_WEB';
    } else {
      return 'ICE_APP';
    }
  }

  getMdpAppName(): string {
    if (this.channel === 'CVS_RETAIL_ANDROID' || this.channel === 'CVS_RETAIL_IPHONE') {
      return 'MDP_APP';
    } else {
      return 'MDP_WEB';
    }
  }

  getUserAgent() {
    return this.deviceDetector.userAgent;
  }

  getDeviceInfo(): void {
    const device = (this.deviceDetector.device || '').toLowerCase();
    const os = (this.deviceDetector.device || '').toLowerCase();
    if (this.deviceDetector.isDesktop()) {
      this.deviceType = 'DESKTOP';
      this.form = 'DESKTOP';
    } else if (device === 'ipad') {
      this.deviceType = 'IOS_TABLET';
      this.form = 'TABLET';
    } else if (device === 'iphone') {
      this.deviceType = 'IOS_MOBILE';
      this.form = 'MOBILE';
    } else if (device === 'windows-phone') {
      this.deviceType = 'WIN_' + (this.deviceDetector.isMobile() ? 'MOBILE' : 'TABLET');
    } else if (os === 'android') {
      this.deviceType = 'AND_' + (this.deviceDetector.isMobile() ? 'MOBILE' : 'TABLET');
    } else {
      this.deviceType = 'OTH_' + (this.deviceDetector.isMobile() ? 'MOBILE' : 'TABLET');
    }
  }

  public getRememberCookieConfDetails(): any {
    return rememberMeCookieDetails;
  }
}
